import { Link } from 'react-router-dom';
import type { Episode } from '@/mocks/siteData';

interface EpisodeCardProps {
  episode: Episode;
}

export default function EpisodeCard({ episode }: EpisodeCardProps) {
  return (
    <Link
      to={`/play/${episode.episode}`}
      className="group flex gap-4 p-4 bg-background-50 border border-background-200 rounded-lg hover:border-accent-400 transition-colors h-full"
    >
      <div className="shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-md bg-primary-50 border border-primary-100 flex flex-col items-center justify-center">
        <span className="text-[10px] text-primary-500 font-label">EP</span>
        <span className="font-heading font-bold text-primary-700 text-xl leading-none">
          {String(episode.episode).padStart(2, '0')}
        </span>
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-heading font-semibold text-foreground-950 text-base leading-snug group-hover:text-primary-700 transition-colors">
            第{episode.episode}集 · {episode.title}
          </h3>
          <i className="ri-arrow-right-s-line text-foreground-400 text-xl shrink-0 group-hover:text-accent-500 group-hover:translate-x-0.5 transition-all"></i>
        </div>
        <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {episode.summary}
        </p>
        <div className="mt-2.5 flex items-center gap-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
            {episode.airDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
            {episode.duration}
          </span>
        </div>
      </div>
    </Link>
  );
}